import axios from "axios";

import logger from "utils/logger";
export function signup(payload) {
  return axios.post("/v1/user/signup", payload);
}

export function getUserInfo() {
  return axios.get(`/v1/userinfo`);
}

/**
 * Situação do usuário perante a versão vigente dos Termos e da Política.
 * Enquanto houver pendência, a versão nova não é oponível a ele.
 */
export function getLegalStatus() {
  return axios.get(`/v1/user/legal-status`);
}

/**
 * Registra o re-aceite. `versions` leva as versões efetivamente exibidas na
 * tela — é isso que o back grava, não o que ele supõe estar vigente.
 */
export function acceptLegalDocuments(documents, versions) {
  return axios.post(`/v1/user/legal-acceptance`, { documents, versions });
}

/** Cópia e portabilidade dos dados do titular (LGPD, art. 18, II e V). */
export function exportMyData() {
  return axios.get(`/v1/user/data-export`);
}

export function updateUserInfo(data) {
  return axios.patch(`/v1/userinfo`, data);
}

export function getUserByUuid(user_uuid) {
  return axios.get(`/v1/user/${user_uuid}`);
}

export function uploadPhotoProfile(file) {
  const formData = new FormData();
  formData.append("0", file);

  return axios.put(`/v1/user/photo-profile`, formData);
}

export function uploadPhotoGallery(file) {
  const formData = new FormData();
  formData.append("0", file);

  return axios.put(`/v1/user/gallery`, formData);
}

export function deletePhotoGallery(photoUrl) {
  return axios.delete(`/v1/user/gallery`, {
    data: { photoUrl },
  });
}

export function setProfilePhotoFromGalleryUrl(photoUrl) {
  return updateUserInfo({ photo: photoUrl });
}

export function getUserPhotos(user_uuid) {
  return axios.get(`/v1/user/photos/${user_uuid}`);
}

export function getTop20Users(city_code, uf, role, gender) {
  const params = new URLSearchParams({ city_code, uf });
  if (role && role !== "todos") params.append("role", role);
  if (gender && gender !== "todos") params.append("gender", gender);
  return axios.get(`/v1/users/top20?${params.toString()}`);
}

/**
 * Busca assinantes em destaque (Premium e Diamante) para o carrossel de destaque.
 * @param {number} limit - número máximo de perfis (default 20)
 * @returns {Promise} Resposta da API com array de perfis
 */
export function getFeaturedSubscribers(limit = 20) {
  return axios.get(`/v1/users/featured?limit=${limit}`);
}

export function advancedSearch(filters, page = 1) {
  return axios.post(`/v1/user/advanced-search?page=${page}`, filters);
}

// Bloqueio de usuário mora em `services/blockService.js` (endpoints /v1/blocks).

export function searchUsers(query, limit = 10) {
  return axios.get(
    `/v1/users/search?q=${encodeURIComponent(query)}&limit=${limit}`,
  );
}

export function deleteAccount(reason) {
  return axios.delete(`/v1/user/account`, {
    data: {
      reason: reason,
    },
  });
}

export function getNotificationPreferences() {
  return axios.get("/v1/notifications/preferences");
}

export function updateNotificationPreferences(prefs) {
  return axios.patch("/v1/notifications/preferences", prefs);
}

export function forgotPassword(email) {
  return axios.post("/v1/user/forgot-password", { email });
}
